import React, { useEffect, useState } from "react";
import tw from "twin.macro";
import { Subheading, H1Heading } from "../misc/Headings.js";
import client from 'sanityClient';
import { useLanguage } from "../../helpers/languageSelector";
import { PAGE_SEO } from "../../seo/seoConfig";

const Container = tw.div`relative max-w-screen-xl mx-auto py-8 flex flex-col items-center bg-white bg-opacity-25`;
const TextContent = tw.div`text-center lg:py-4 max-w-4xl`;
const BrandHeading = tw.p`text-4xl sm:text-5xl lg:text-6xl font-extrabold leading-tight max-w-full tracking-wide text-center`;
const Heading = tw(H1Heading)`text-2xl sm:text-3xl lg:text-4xl font-black leading-tight max-w-full mt-2`;
const NarrowDescription = tw.div`sm:mx-4 md:mx-16 lg:mx-24 mt-4 px-4 leading-loose`;
const Description = ({ text }) => (
  <NarrowDescription>
    <p
      tw="text-center leading-loose text-sm md:text-base lg:text-lg font-medium text-secondary-100 whitespace-pre-line"
      dangerouslySetInnerHTML={{ __html: text.replace(/\n/g, '<br />') }}
    />
  </NarrowDescription>
);

export default () => {
  const { currentLanguage } = useLanguage();
  const [content, setContent] = useState({ heading: '', subheading: '', description: '' });
  const seoH1 = PAGE_SEO[`/${currentLanguage}`]?.h1Fallback;

  useEffect(() => {
    client.fetch(`*[_type == "mainFeature" && language == "${currentLanguage}"][0]`)
      .then((data) => {
        setContent(data);
      })
      .catch((error) => console.error('Error fetching data:', error));
  }, [currentLanguage]);

  return (
    <Container>
      <TextContent>
        {content.heading && <BrandHeading>{content.heading}</BrandHeading>}
        <Heading>{seoH1 || content.heading}</Heading>
        {content.subheading && <Subheading>{content.subheading}</Subheading>}
        {content.description && <Description text={content.description} />}
      </TextContent>
    </Container>
  );
};
